

document.addEventListener("DOMContentLoaded", function() {

  const variantSelects = document.querySelectorAll("variant-selects");
  
  variantSelects.forEach(wrapper => {
    wrapper.querySelectorAll('input[type="radio"]').forEach(input => {
  
      input.removeAttribute('checked');
      console.log('Removed checked attribute from:', input);
    });
  });
  

  const quickViewVariants = document.querySelectorAll('.quick-view variant-selects, [data-quick-view] variant-selects');
  quickViewVariants.forEach(wrapper => {
    wrapper.querySelectorAll('input[type="radio"]').forEach(input => {
      input.removeAttribute('checked');
      console.log('Quick View: Removed checked attribute from:', input);
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  console.log('Active class handler loaded for all variants');
  

  document.addEventListener('click', function(e) {
    const wrap = e.target.closest('.custom-input-label-wrap');
    
    if (wrap) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Wrap clicked in:', wrap.closest('.quick-view') ? 'Quick View' : 'Main Product');
      
     
      const parentRadios = wrap.closest('variant-radios');
      
      if (parentRadios) {
       
        parentRadios.querySelectorAll('.custom-input-label-wrap').forEach(w => {
          w.classList.remove('active');
        });
      }
      
   
      wrap.classList.add('active');
      
  
      const radio = wrap.querySelector('input[type="radio"]');
      if (radio) {
       
        radio.checked = true;
        
   
        radio.setAttribute('checked', 'checked');
        
    
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        
        console.log('Radio checked and attribute added');
      }
    }
  });
  

  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"]')) {
      const wrap = e.target.closest('.custom-input-label-wrap');
      
      if (wrap && e.target.checked) {
    
        const parentRadios = wrap.closest('variant-radios');
        if (parentRadios) {
          parentRadios.querySelectorAll('.custom-input-label-wrap').forEach(w => {
            w.classList.remove('active');
          });
        }
        
      
        wrap.classList.add('active');
        
      
        e.target.setAttribute('checked', 'checked');
      }
    }
  });
  
  setTimeout(() => {

    document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
      const wrap = radio.closest('.custom-input-label-wrap');
      if (wrap) {
        const parentRadios = wrap.closest('variant-radios');
        if (parentRadios) {
          parentRadios.querySelectorAll('.custom-input-label-wrap').forEach(w => {
            w.classList.remove('active');
          });
        }
        wrap.classList.add('active');
        console.log('Initial active class set for checked radio in:', 
          wrap.closest('.quick-view') ? 'Quick View' : 'Main Product');
      }
    });
  }, 500);
});


const variantObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { 
    
          const newVariants = node.querySelectorAll ? node.querySelectorAll('variant-selects') : [];
          if (node.matches && node.matches('variant-selects')) {
    
            node.querySelectorAll('input[type="radio"]').forEach(input => {
              input.removeAttribute('checked');
            });
          }
          
          newVariants.forEach(variantWrapper => {
            variantWrapper.querySelectorAll('input[type="radio"]').forEach(input => {
              input.removeAttribute('checked');
              console.log('New variant: removed checked attribute');
            });
          });
        }
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  variantObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', function() {
  console.log('Close button handler loaded');
  

  document.addEventListener('click', function(e) {
    const closeBtn = e.target.closest('.popup-wrapper__quick-view.main-product button.button-close.close-popup');
    
    if (closeBtn) {
      console.log('Close button clicked - removing checked states from Quick View');
      
   
      const quickViewPopup = closeBtn.closest('.popup-wrapper__quick-view.main-product');
      
      if (quickViewPopup) {

        const variantRadiosList = quickViewPopup.querySelectorAll('variant-radios');
        
        variantRadiosList.forEach(variantRadios => {

          variantRadios.querySelectorAll('.custom-input-label-wrap').forEach(wrap => {
            wrap.classList.remove('active');
          });
          
 
          variantRadios.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = false;
            input.removeAttribute('checked');
            

            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        

        const variantSelectsList = quickViewPopup.querySelectorAll('variant-selects');
        variantSelectsList.forEach(variantSelects => {
          variantSelects.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = false;
            input.removeAttribute('checked');
          });
        });
        
        console.log('All checked states removed from Quick View');
  
        userSelectedVariant = false;
        console.log('userSelectedVariant flag reset to false');
        

        document.querySelectorAll('.product-form__submit[name="add"]').forEach(btn => {
          btn.classList.add('is-disabled');
        });
        
        disableDynamicCheckout();
      }
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const quickViewPopup = document.querySelector('.popup-wrapper__quick-view.main-product[style*="display: block"]');
      
      if (quickViewPopup) {
        console.log('ESC pressed - removing checked states from Quick View');
        
        const variantRadiosList = quickViewPopup.querySelectorAll('variant-radios');
        
        variantRadiosList.forEach(variantRadios => {
          variantRadios.querySelectorAll('.custom-input-label-wrap').forEach(wrap => {
            wrap.classList.remove('active');
          });
          
          variantRadios.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = false;
            input.removeAttribute('checked');
          });
        });
        
        userSelectedVariant = false;
        console.log('userSelectedVariant flag reset to false (ESC)');
        
        document.querySelectorAll('.product-form__submit[name="add"]').forEach(btn => {
          btn.classList.add('is-disabled');
        });
        
        disableDynamicCheckout();
      }
    }
  });
});

let userSelectedVariant = false;

function disableDynamicCheckout() {
  document.querySelectorAll('shopify-buy-it-now-button button').forEach(btn => {
    btn.classList.add('is-disabled');
  });
}

function enableDynamicCheckout() {
  document.querySelectorAll('shopify-buy-it-now-button button').forEach(btn => {
    btn.classList.remove('is-disabled');
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product-form__submit[name="add"]').forEach(btn => {
    btn.classList.add('is-disabled');
  });

  disableDynamicCheckout();
});

document.addEventListener("change", function (e) {
  if (e.target.matches('variant-selects input[type="radio"], variant-selects select')) {
    userSelectedVariant = true;

    document.querySelectorAll('.product-form__submit[name="add"]').forEach(btn => {
      btn.classList.remove('is-disabled');
    });

    enableDynamicCheckout();

    document.querySelectorAll(".product-form__error-message-wrapper")
      .forEach(wrapper => wrapper.setAttribute("hidden", true));
  }
});

// document.addEventListener("click", function (e) {
//   const atcBtn = e.target.closest('.product-form__submit[name="add"]');
//   const buyNowBtn = e.target.closest('shopify-buy-it-now-button button');

//   if (!atcBtn && !buyNowBtn) return;

//   if (!userSelectedVariant) {
//     e.preventDefault();
//     e.stopImmediatePropagation();

//     const productForm = (atcBtn || buyNowBtn).closest("product-form");
//     if (!productForm) return;

//     const errorWrapper = productForm.querySelector(".product-form__error-message-wrapper");
//     const errorText = productForm.querySelector(".product-form__error-message");

//     errorText.textContent = "Please select a size first.";
//     errorWrapper.removeAttribute("hidden");

//     const variantWrapper = productForm.querySelector("variant-selects");

//     if (variantWrapper) {
//       variantWrapper.scrollIntoView({
//         behavior: "smooth",
//         block: "center"
//       });
//     }
//   }
// }, true);


function isDesktop() {
  return window.innerWidth >= 768;
}

document.addEventListener("click", function (e) {

  if (!isDesktop()) return;

  const atcBtn = e.target.closest('.product-form__submit[name="add"]');
  const buyNowBtn = e.target.closest('shopify-buy-it-now-button button');

  if (!atcBtn && !buyNowBtn) return;

  if (!userSelectedVariant) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const errorWrapper = document.querySelector(".product-form__error-message-wrapper");
    const errorText = document.querySelector("#product-form__error-message");
    const variantPicker = document.querySelector("#variant-picker");

    if (errorText) {
      errorText.textContent = "Please select a size first.";
    }

    if (errorWrapper) {
      errorWrapper.removeAttribute("hidden");
    }

    if (variantPicker) {
      variantPicker.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }

}, true);


const observer = new MutationObserver(() => {
  if (!userSelectedVariant) {
    disableDynamicCheckout();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});